export const BRAND_LOGOS = {
  pipedrive:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Pipedrive_Logo.svg/960px-Pipedrive_Logo.svg.png",
  whatsable: "https://whatsable.app/apps-logo/whatsable-logo-transparent.svg",
  notifyer:
    "https://res.cloudinary.com/subframe/image/upload/v1756457825/uploads/4086/b4ynd9jid16pcby8cfz0.svg",
} as const;

function BrandLogo({ src, alt }: { src: string; alt: string }) {
  return (
    <div className="flex h-14 w-[108px] items-center justify-center rounded-lg border border-gray-100 bg-white px-3">
      <img
        src={src}
        alt={alt}
        className="max-h-9 max-w-full object-contain"
        loading="eager"
        decoding="async"
        referrerPolicy="no-referrer"
      />
    </div>
  );
}

export default function BrandLogoStrip({ className = "mb-8" }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center gap-2 ${className}`}>
      <BrandLogo src={BRAND_LOGOS.pipedrive} alt="Pipedrive" />
      <span className="text-sm text-gray-300" aria-hidden>
        ×
      </span>
      <BrandLogo src={BRAND_LOGOS.whatsable} alt="WhatsAble" />
      <span className="text-sm text-gray-300" aria-hidden>
        ×
      </span>
      <BrandLogo src={BRAND_LOGOS.notifyer} alt="Notifyer" />
    </div>
  );
}
